import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { CreateSpaceQuery } from '@confluence/create-space-preload/entry-points/preloadCreateSpace.ts';
import type {
	CreateSpaceQueryType,
	CreateSpaceQueryUserConfluenceOperationsType as Operations,
} from '@confluence/create-space-preload/entry-points/preloadCreateSpace.ts';

export const useCanCreateSpace = () => {
	const { isLicensed } = useSessionData();

	const { data: canCreateData } = useQuery<CreateSpaceQueryType>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		CreateSpaceQuery,
		{
			skip: !isLicensed,
		},
	);

	const canCreateSpace = Boolean(
		canCreateData?.user?.confluence?.operations.some(
			(obj: Operations | null) => obj?.operation === 'create_space',
		),
	);

	return { canCreateSpace };
};
